<template>
	<section class="faq-card">
		<div class="section-heading">
			<div class="heading-icon"><i class="el-icon-question"></i></div>
			<div>
				<h3>常见问题</h3>
				<p>关于企业认证与授权的常见问题说明</p>
			</div>
		</div>
		<div class="faq-list">
			<div v-for="(item, index) in questions" :key="item.question" class="faq-item">
				<div class="faq-question">
					<span class="question-index">{{ index + 1 }}</span>
					<span>{{ item.question }}</span>
				</div>
				<p>{{ item.answer }}</p>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'CompanyFaq',
		data() {
			return {
				questions: [
					{
						question: '个人用户可以自己申请企业认证吗？',
						answer: '不可以。个人用户的企业认证需由所属企业管理员发起授权，授权成功后系统将自动完成企业认证。'
					},
					{
						question: '没关联企业会影响领券和下单吗？',
						answer: '不会。领券、下单、会员等级及个人权益均与当前账号相关，不会因是否关联企业而受到影响。'
					},
					{
						question: '关联企业有什么用？',
						answer: '关联企业用于确认个人用户与企业的授权关系，便于使用后续面向企业成员开放的身份识别及协同服务。'
					},
					{
						question: '一个个人账号可以被多个企业授权吗？',
						answer: '当前一个个人账号同一时间仅能关联一家企业。如需变更企业，请先解除现有绑定，并遵循解绑后再次授权的时间规则。'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.faq-card {
		margin-top: 20px;
		padding: 22px;
		border: 1px solid #e5eaf1;
		border-radius: 8px;
		background: #ffffff;
	}

	.section-heading {
		display: flex;
		align-items: center;
		margin-bottom: 20px;

		.heading-icon {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 42px;
			height: 42px;
			margin-right: 13px;
			border-radius: 10px;
			color: #d68b26;
			font-size: 22px;
			background: #fff6e8;
		}

		h3 {
			margin: 0 0 5px;
			font-size: 18px;
			color: #303846;
		}

		p {
			margin: 0;
			color: #9098a5;
			font-size: 13px;
		}
	}

	.faq-list {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 16px;
	}

	.faq-item {
		min-width: 0;
		padding: 18px;
		border: 1px solid #e5eaf1;
		border-radius: 8px;
		background: #fafbfd;
		transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;

		&:hover {
			border-color: #b7d3f3;
			box-shadow: 0 7px 18px rgba(38, 113, 203, 0.09);
			transform: translateY(-2px);
		}

		.faq-question {
			display: flex;
			align-items: center;
			color: #303846;
			font-size: 15px;
			font-weight: 500;
			line-height: 22px;
		}

		.question-index {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 24px;
			height: 24px;
			margin-right: 12px;
			border-radius: 50%;
			color: #2671cb;
			font-size: 13px;
			background: #edf5ff;
		}

		p {
			margin: 13px 0 0 36px;
			color: #6f7886;
			font-size: 14px;
			line-height: 24px;
		}
	}

	@media (max-width: 1000px) {
		.faq-list {
			grid-template-columns: 1fr;
		}
	}
</style>
